import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import NoAccess from './NoAccess';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, productAccess } = useAuth();

  if (loading) {
    return (
      <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  // Logged in, but the org they selected isn't served by this product -> deny access.
  if (productAccess === false) return <NoAccess />;
  return children;
};

export default PrivateRoute;
